import { IGetItemsParams } from '../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';
import { ISchedule } from './ISchedule';
import { Request } from '../../httpClient/serverApi/requests/Request';

export interface IGetSchedulesResult extends IGetItemsResult {
  schedules: ISchedule[];
}

export class GetSchedulesRequest extends Request<IGetItemsParams, IGetSchedulesResult> {
  constructor(params: IGetItemsParams) {
    super('getSchedules', params);
  }
}
